import styled from '@emotion/styled'

const ImageStyled = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  .gatsby-image-wrapper {
    // width: 100% !important;
    // height: 100% !important;
    width: 100%;
    height: 100%;

    img {
      //opacity: 1 !important;
      max-width: 100%;
      height: auto;
    }
  }
`

export { ImageStyled }
